export const coachingStageLabel = {
  beforeCoaching: "Avant l'accompagnement",
  coaching: "Pendant l'accompagnement",
  coached: "Fin d'accompagnement",
  "": "Sans étape",
};
